import { useState } from "react";

type DataModal<T = unknown> = {
  activeModal: string | null;
  activeModalData: T | null;
  activeModalErrors?: unknown | null;
};

export type onToggleDataModalFn<T = unknown> = (
  values: T,
  name: string
) => void;

const useDataModal = <T>(): {
  data: DataModal<T>;
  onToggle: onToggleDataModalFn;
} => {
  const [data, setData] = useState<DataModal<T>>({
    activeModal: null,
    activeModalData: null,
    activeModalErrors: null
  });

  const toggleModal = (values: T, name: string) => {
    setData({
      activeModal: name,
      activeModalData: values
    });
  };

  return { data, onToggle: toggleModal };
};

export default useDataModal;
